import { useState } from 'react';

export function useModalState() {
  const [isSubmitModalVisible, setSubmitModalVisible] = useState(false);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [isApproveModalVisible, setIsApproveModalVisible] = useState(false);
  const [isApproveBudgetModalVisible, setIsApproveBudgetModalVisible] = useState(false);

  const handleToggleSubmitModalVisibility = () => setSubmitModalVisible(!isSubmitModalVisible);
  const handleToggleDeleteModalVisibility = () => setDeleteModalVisible(!isDeleteModalVisible);
  const handleToggleApproveModalVisibility = () => setIsApproveModalVisible(!isApproveModalVisible);
  const handleToggleApproveBudgetModalVisibility = () => setIsApproveBudgetModalVisible(!isApproveBudgetModalVisible);

  return {
    isSubmitModalVisible,
    isDeleteModalVisible,
    isApproveModalVisible,
    isApproveBudgetModalVisible,
    handleToggleSubmitModalVisibility,
    handleToggleDeleteModalVisibility,
    handleToggleApproveModalVisibility,
    handleToggleApproveBudgetModalVisibility,
  };
}
